import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "exportformat"
    }}>{`ExportFormat`}</h1>
    <p>{`Export format options.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`TAGGED_TEXT`}</strong>{` = 1416066168`}</p>
      <p parentName="blockquote">{`Exports to a tagged text file with a TXT extension.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`PDF_TYPE`}</strong>{` = 1952403524`}</p>
      <p parentName="blockquote">{`Exports to PDF format.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`EPS_TYPE`}</strong>{` = 1952400720`}</p>
      <p parentName="blockquote">{`Exports to EPS format.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`RTF`}</strong>{` = 1381254688`}</p>
      <p parentName="blockquote">{`Exports to rich text format (RTF).`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`TEXT_TYPE`}</strong>{` = 1952412773`}</p>
      <p parentName="blockquote">{`Exports to text (TXT) format.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`XML`}</strong>{` = 1481460768`}</p>
      <p parentName="blockquote">{`Exports the document's tagged content to XML.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`JPG`}</strong>{` = 1246775072`}</p>
      <p parentName="blockquote">{`Exports to JPEG format.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`INTERACTIVE_PDF`}</strong>{` = 1952409936`}</p>
      <p parentName="blockquote">{`Exports to Interactive PDF format.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`FIXED_LAYOUT_EPUB`}</strong>{` = 1701865080`}</p>
      <p parentName="blockquote">{`Exports to fixed layout EPub format.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`HTMLFXL`}</strong>{` = 1213490808`}</p>
      <p parentName="blockquote">{`Exports to XHTML FXL format.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`INDESIGN_SNIPPET`}</strong>{` = 1936617588`}</p>
      <p parentName="blockquote">{`Exports to InDesign snippet (IDMS) format.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`INDESIGN_MARKUP`}</strong>{` = 1768189292`}</p>
      <p parentName="blockquote">{`Exports to InDesign markup (IDML) format.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`INCOPY_MARKUP`}</strong>{` = 1768123756`}</p>
      <p parentName="blockquote">{`Exports to InCopy markup (ICML) format.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`PNG_FORMAT`}</strong>{` = 1699761735`}</p>
      <p parentName="blockquote">{`Exports to PNG format.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`HTML`}</strong>{` = 1213484364`}</p>
      <p parentName="blockquote">{`Exports to XHTML format.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`EPUB`}</strong>{` = 1701868898`}</p>
      <p parentName="blockquote">{`Exports to EPub format.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      